module.exports = __webpack_public_path__ + "img/user-group-crown.ba93152e.svg";